import React, { useEffect, useState } from "react";
import axios from "axios";
import { Loader2, Lock } from "lucide-react";
import { LogoIcon } from "@/components/Logo";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/site`;
const KEY = "meterox_site_token";

export const siteLogout = () => {
  sessionStorage.removeItem(KEY);
  window.location.reload();
};

export default function SiteGate({ children }) {
  const [state, setState] = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem(KEY);
    if (!token) { setState(false); return; }
    axios.get(`${API}/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => setState(true))
      .catch(() => { sessionStorage.removeItem(KEY); setState(false); });
  }, []);

  if (state === null) {
    return <div className="flex min-h-screen items-center justify-center bg-background"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;
  }
  if (state) return children;
  return <SiteLoginForm onSuccess={() => setState(true)} />;
}

function SiteLoginForm({ onSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/login`, { username, password });
      sessionStorage.setItem(KEY, data.token);
      onSuccess();
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Accesso non riuscito");
    } finally {
      setLoading(false);
    }
  };

  const field = "h-11 w-full rounded-none border border-input bg-surface px-3 font-mono text-sm outline-none focus:border-primary";
  return (
    <div data-testid="site-login" className="flex min-h-screen items-center justify-center bg-background px-4 text-foreground">
      <div className="w-full max-w-sm border border-border bg-card p-8">
        <div className="mb-8 flex items-center gap-3">
          <LogoIcon className="h-12 w-12" />
          <div>
            <div className="font-display text-2xl font-black tracking-tight">METEROX</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Accesso riservato</div>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="label-caps mb-1.5 block text-muted-foreground">Username</label>
            <input data-testid="site-login-username" autoComplete="username" value={username} onChange={(e) => setUsername(e.target.value)} required className={field} />
          </div>
          <div>
            <label className="label-caps mb-1.5 block text-muted-foreground">Password</label>
            <input data-testid="site-login-password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required className={field} />
          </div>
          {error && <p data-testid="site-login-error" className="text-sm text-destructive">{error}</p>}
          <Button data-testid="site-login-submit" type="submit" disabled={loading} className="h-11 w-full rounded-none bg-primary font-bold text-primary-foreground hover:opacity-90">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Lock className="mr-2 h-4 w-4" /> Accedi</>}
          </Button>
        </form>
      </div>
    </div>
  );
}
